'use client';
// import ErrorMsg from '@/components/Error/ErrorMsg';

import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { ErrorPageType } from '@/common/enums';
import { useRouter } from 'next/navigation';

type ErrorHandlerProps = {
    errorPageType?: ErrorPageType;
};

const ErrorHandler = ({ errorPageType }: ErrorHandlerProps) => {
    const router = useRouter();
    const { t } = useTranslation();

    const reload = useCallback(() => {
        window.location.reload();
    }, []);
    const goHome = useCallback(() => {
        router.push(`/`);
    }, [router]);
    let renderedError = <>404</>;
    // switch (errorPageType) {
    //     case ErrorPageType.noaccess:
    //         renderedError = (
    //             <ErrorMsg
    //                 onRetry={goHome}
    //                 retryText={t('errorMsg.viewMore').toString()}
    //                 msg={t('errorMsg.notAvailableForCustomer').toString()}
    //             ></ErrorMsg>
    //         );
    //         break;
    //     case ErrorPageType.nolocale:
    //         renderedError = (
    //             <ErrorMsg
    //                 onRetry={goHome}
    //                 retryText={t('errorMsg.backToMain').toString()}
    //                 msg={t('errorMsg.notAvailableForLanguage').toString()}
    //             ></ErrorMsg>
    //         );
    //         break;
    //     case ErrorPageType.notFound:
    //         renderedError = (
    //             <ErrorMsg
    //                 onRetry={goHome}
    //                 retryText={t('errorMsg.backToMain').toString()}
    //             ></ErrorMsg>
    //         );
    //         break;
    //     case ErrorPageType.unPublished:
    //         renderedError = (
    //             <ErrorMsg
    //                 onRetry={goHome}
    //                 msg={t('errorMsg.unPublished').toString()}
    //                 retryText={t('errorMsg.backtoHome').toString()}
    //             ></ErrorMsg>
    //         );
    //         break;
    //     default:
    //         renderedError = <ErrorMsg onRetry={reload}></ErrorMsg>;
    //         break;
    // }

    return (
        <div className='bg-[#F6F7F8] h-[100vh] flex justify-center items-center'>
            <div className='relative bottom-16'>{renderedError}</div>
        </div>
    );
};

export default ErrorHandler;
